import { ApiRequest } from "../../services/api";

export const PatchClientEmails = async (data) => {
  return await ApiRequest("PATCH", "admin/client-emails", data);
};
